module.exports = __webpack_public_path__ + "static/media/builder_refer_to.aa986c3b.gif";